import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment as DEV } from "../../../environments/environment";
import { environment as PROD } from "../../../environments/environment.prod";


@Injectable({
  providedIn: 'root'
})
export class HttpService {
  apiUrl:string = '';
  constructor(private http: HttpClient) { 
    this.initConfig(); 
   }
 initConfig() {
        if (window.location.href.includes('dev')) {
            this.apiUrl = DEV.apiUrl;           
        } else {
            this.apiUrl = PROD.apiUrl;
        }
    }

  get(endpoint: string, params: any = {}, headers: any = {}): Observable<any> {
    return this.http.get(this.apiUrl + endpoint, {
        params: params,
        headers: new HttpHeaders(headers)
    });
}

post(endpoint: string, body: any = {}, headers: any = {}): Observable<any> {
    return this.http.post(this.apiUrl + endpoint, body, {
        headers: new HttpHeaders(headers)
    });
}

put(endpoint: string, body: any = {}, headers: any = {}): Observable<any> {
    return this.http.put(this.apiUrl + endpoint, body, {
        headers: new HttpHeaders(headers)
    });
}

delete(endpoint: string, params: any = {}, headers: any = {}): Observable<any> {
    return this.http.delete(this.apiUrl + endpoint, {
        params: params,
        headers: new HttpHeaders(headers)
    });
}
}
